module.exports = __webpack_public_path__ + "img/haarlem_logo.f07c0445.svg";